// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const floette: PokeData = {
  "id": 670,
  "name": "floette",
  "height": 2,
  "weight": 9,
  "base_experience": 130,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "vine-whip",
    "tackle",
    "razor-leaf",
    "solar-beam",
    "petal-dance",
    "safeguard",
    "synthesis",
    "wish",
    "aromatherapy",
    "magical-leaf",
    "lucky-chant",
    "petal-blizzard",
    "grassy-terrain",
    "misty-terrain",
    "fairy-wind",
    "moonblast"
  ],
  "moves": [
    "vine-whip",
    "tackle",
    "razor-leaf",
    "solar-beam",
    "synthesis",
    "aromatherapy",
    "grassy-terrain",
    "misty-terrain",
    "moonblast",
    "sweet-kiss",
    "mist-terrain",
    "starfall",
    "moonlight"
  ],
  "evolution_chain": {
    "id": 344,
    "item": null,
    "species": [
      {
        "name": "flabebe",
        "order": 670,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "floette",
        "order": 671,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 669,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 19,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "florges",
        "order": 672,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 670,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "shiny-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 63.25,
    "speed": 52,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
